import React from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import appConfig from '@/config/appConfig.typed';
import ROUTE_PARAMS from '@/consts/route/routeParams';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import appRouterService from '@/services/route/appRouterService';
import uwmService from '@/services/uwm/uwmService';
import {selectDeviceType} from '@/state/selectors/device';
import UwmModule from '@/views/UwmModule/UwmModule';

const TipsAndTutorials = ({
    isQuickStartGuide,
    isCleaningGuide,
    isAdvancedDiagnostic,
    onBack,
    skipFirstStep,
    deviceType: deviceTypeFromProps,
}) => {
    const {[ROUTE_PARAMS.DEVICE_TYPE]: deviceTypeFromQuery} = useParams();
    const deviceTypeFromState = useSelector(selectDeviceType);
    const deviceType = deviceTypeFromProps || deviceTypeFromQuery || deviceTypeFromState;

    const supportExternalLink = appConfig.getSupportExternalLink();
    const {redirectToExternalLink: redirectToSupport} = useConfigExternalLink(supportExternalLink);

    const onModuleLoaded = () => {
        uwmService.postTipsAndTutorialsInitMessage({isQuickStartGuide, isCleaningGuide, deviceType, skipFirstStep});
        uwmService.postMarketLocaleInitMessage();
    };

    const onCompleteCleaningGuide = () => {
        if (isAdvancedDiagnostic) {
            appRouterService.forwardToPostCleaningAD();
        } else {
            appRouterService.forwardToHomePage();
        }
    };

    return (
        <UwmModule
            onBack={onBack}
            onModuleLoaded={onModuleLoaded}
            onSupportButtonClick={redirectToSupport}
            src={process.env.REACT_APP_UWM_TIPS_AND_TUTORIALS_SRC}
            onCompleteCleaningGuide={onCompleteCleaningGuide}
        />
    );
};

export default TipsAndTutorials;
